import React, { useEffect, useState } from 'react';
import { 
    Container, Box, Typography, Grid, Card, CardContent, CardMedia, 
    IconButton, TextField, InputAdornment 
} from '@mui/material';
import {
    Search as SearchIcon, Info as InfoIcon, Phone as PhoneIcon, Email as EmailIcon, AttachMoney as MoneyIcon,
    Description as DescriptionIcon, Balance as BalanceIcon, Gavel as GavelIcon, Handshake as HandshakeIcon,
    DirectionsCar as DirectionsCarIcon, People as PeopleIcon, LocalHospital as LocalHospitalIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import TitleSection from './utils/TittleTheme';

export default function Transparencia({ config }) {
    const [searchTerm, setSearchTerm] = useState('');

    // Visibilidade Geral obtida das configurações
    const visibilidade = config?.transparencia_visibilidade || {};

    // Helper para checar se o item deve ser exibido (Por padrão todos são TRUE)
    const isVisible = (key) => {
        if (!key) return true;
        return visibilidade[key] !== false;
    };

    // Pega os cards customizados com foto (somente os com exibir !== false)
    const customCardsRaw = config?.transparencia?.card || [];
    const customCards = Array.isArray(customCardsRaw)
        ? customCardsRaw.filter(item => item && item.nome && item.foto && item.link && item.exibir !== false)
        : [];

    // Pega os itens personalizados antigos (somente os com exibir !== false)
    const customItemsRaw = config?.transparencia_outros || [];
    const customItems = Array.isArray(customItemsRaw)
        ? customItemsRaw
            .filter(item => item && item.exibir !== false)
            .map(item => ({
                icon: <DescriptionIcon fontSize="large" />, 
                title: item.nome || 'Item sem nome',
                link: item.link || '#',
                itemType: "https://turmalina.tcepb.tc.br/documentation/OtherInformation",
            }))
        : [];

    const customSection = customItems.length > 0
        ? [{
            title: "Outros",
            description: "Documentos e informações adicionais",
            items: customItems,
        }]
        : [];

    const rawSections = [
        {
            title: "Canais de Atendimento",
            description: "Lei Nº 12.527 (Acesso a Informação) - Lei Nº 13.460 (Carta de Serviços)",
            items: [
                { key: "esic", icon: <InfoIcon fontSize="large" />, title: "e-SIC", link: "/e-sic", itemType: "https://turmalina.tcepb.tc.br/documentation/CommunicationChannel" },
                { key: "ouvidoria", icon: <PhoneIcon fontSize="large" />, title: "Ouvidoria", link: "/ouvidoria", itemType: "https://turmalina.tcepb.tc.br/documentation/CommunicationChannel" },
                { key: "cartaDeServicos", icon: <EmailIcon fontSize="large" />, title: "Carta de Serviços", link: "/carta-de-servico", itemType: "https://turmalina.tcepb.tc.br/documentation/ServiceLetter" },
            ],
        },
        {
            title: "Receitas e Despesas",
            description: "Lei Nº 12.527 (Acesso a Informação) - Lei Complementar Nº 131 (Transparência)",
            itemtype: "https://turmalina.tcepb.tc.br/documentation/BudgetRevenue",
            items: [
                {
                    key: "receitaOrcamentaria",
                    icon: <MoneyIcon fontSize="large" />,
                    title: "Receita Orçamentária",
                    link: config?.transparencia?.receitaOrcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetRevenue"
                },
                {
                    key: "receitaExtraorcamentaria",
                    icon: <MoneyIcon fontSize="large" />,
                    title: "Receita Extraorçamentária",
                    link: config?.transparencia?.receitaExtraorcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/ExtraBudgetRevenue"
                },
                {
                    key: "despesaOrcamentaria",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Despesa Orçamentária",
                    link: config?.transparencia?.despesaOrcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetExpenditure"
                },
                {
                    key: "despesaExtraorcamentaria",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Despesa Extraorçamentária",
                    link: config?.transparencia?.despesaExtraorcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/ExtraBudgetExpenditure"
                },
                {
                    key: "documentoPagamento",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Documento de Pagamento",
                    link: config?.transparencia?.documentoPagamento || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/PaymentDocument"
                },
            ]
        },
        {
            title: "Atos, publicações, pessoal, compras e convênios",
            description: "Lei Nº 12.527 (Acesso a Informação)",
            itemType: "https://turmalina.tcepb.tc.br/documentation/PlanningInstrument",
            items: [
                {
                    key: "instrumentosPlanejamento",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Instrumentos de Planejamento",
                    link: config?.transparencia?.instrumentosPlanejamento || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/PlanningInstrument"
                },
                {
                    key: "leismunicipais",
                    icon: <BalanceIcon fontSize="large" />,
                    title: "Leis Municipais",
                    link: config?.transparencia?.leismunicipais || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LegalInstrument"
                },
                {
                    key: "decretos",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Decretos",
                    link: config?.transparencia?.decretos || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LegalInstrument"
                },
                {
                    key: "subvencaoSocial",
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Subvenções Sociais",
                    link: config?.transparencia?.subvencaoSocial || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Subsidies"
                },
                {
                    key: "emendasImpositivas",
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Emendas Impositivas",
                    link: config?.transparencia?.emendasImpositivas || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/ImpositiveAmendments"
                },
                {
                    key: "pessoal",
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Pessoal",
                    link: config?.transparencia?.pessoal || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/EmployeeInformation"
                },
                {
                    key: "licitacoes",
                    icon: <GavelIcon fontSize="large" />,
                    title: "Licitações",
                    link: config?.transparencia?.licitacoes || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Bidding"
                },
                {
                    key: "publicacoes",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Publicações",
                    link: config?.transparencia?.publicacoes || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Publications"
                },
                {
                    key: "contratosLicitatorios",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Contratos licitatórios",
                    link: config?.transparencia?.contratosLicitatorios || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Contract"
                },
                {
                    key: "contratos",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Contratos",
                    link: config?.transparencia?.contratos || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Contract"
                },
                {
                    key: "conveniosFederal",
                    icon: <HandshakeIcon fontSize="large" />,
                    title: "Convênios Federal",
                    link: config?.transparencia?.conveniosFederal || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Agreement"
                },
                {
                    key: "recursosFederais",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Recursos Federais",
                    link: config?.transparencia?.recursosFederais || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/FederalResources"
                },
                {
                    key: "estagiarios",
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Estagiários",
                    link: config?.transparencia?.estagiarios || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Interns"
                },
                {
                    key: "covid19",
                    icon: <LocalHospitalIcon fontSize="large" />,
                    title: "COVID-19",
                    link: config?.transparencia?.covid19 || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/EmergencyExpenditure"
                },
                {
                    key: "frotaMunicipal",
                    icon: <DirectionsCarIcon fontSize="large" />,
                    title: "Frota Municipal",
                    link: config?.transparencia?.frotaMunicipal || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/VehicleFleet"
                },
            ]
        },
        {
            title: "Regulamentações e Instrumentos de Pagamento",
            description: "Normas, Regulamentações, Pareceres, Planos e Informativos",
            itemType: "https://turmalina.tcepb.tc.br/documentation/PlanningInstrument",
            items: [
                {
                    key: "rreo",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "RREO",
                    link: config?.transparencia?.rreo || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetReport"
                },
                {
                    key: "rgf",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "RGF",
                    link: config?.transparencia?.rgf || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/FiscalResponsibilityReport"
                },
                {
                    key: "loa",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "LOA",
                    link: config?.transparencia?.loa || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/AnnualBudgetLaw"
                },
                {
                    key: "ldo",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "LDO",
                    link: config?.transparencia?.ldo || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetGuidelinesLaw"
                },
                {
                    key: "ppa",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "PPA",
                    link: config?.transparencia?.ppa || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/MultiyearPlan"
                },
                {
                    key: "regulamentacaoLAI",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Regulamentação da LAI",
                    link: config?.transparencia?.regulamentacaoLAI || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LAIRegulation"
                },
                {
                    key: "regulamentacaoDiarias",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Regulamentação das Diárias",
                    link: config?.transparencia?.regulamentacaoDiarias || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/TravelExpenseRegulation"
                },
                {
                    key: "renunciasFiscais",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Renúncias Fiscais",
                    link: config?.transparencia?.renunciasFiscais || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/TaxWaivers"
                },
                {
                    key: "lgpd",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Informações de LGPD",
                    link: config?.transparencia?.lgpd || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LGPDInformation"
                },
                {
                    key: "tabelaDiarias",
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Tabela de Valores das Diárias",
                    link: config?.transparencia?.tabelaDiarias || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/TravelAllowanceTable"
                },
            ]
        },
        ...customSection
    ];

    // Filtra itens de cada seção com base na visibilidade individual
    const sections = rawSections
        .map(section => ({
            ...section,
            items: section.items.filter(item => isVisible(item.key))
        }))
        .filter(section => section.items.length > 0); // Remove seções que ficaram sem nenhum item visível

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <TitleSection title={'PORTAL DA TRANSPARÊNCIA'} subtitle={'Acesso à Informação e Prestação de Contas com Clareza e Responsabilidade'} />

            <Box sx={{ mb: 4 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Pesquisar por LOA, LDO, receitas, despesas..."
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color="action" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                        }
                    }}
                />
            </Box>

            {/* Destaques (Cards em Destaque) */}
            {customCards.length > 0 && (
                <Box sx={{ mb: 5 }}>
                    <Typography variant="h5" component="div" fontWeight="700" gutterBottom>
                        Destaques da Transparência
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Acesso rápido aos principais painéis informativos.
                    </Typography>

                    <Grid container spacing={3}>
                        {customCards
                            .filter((item) => item.nome.toLowerCase().includes(searchTerm))
                            .map((item) => (
                                <Grid item xs={12} sm={6} md={4} key={item.id || item.nome}>
                                    <Link style={{ textDecoration: 'none' }} to={item.link}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                borderRadius: '12px',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                '&:hover': {
                                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                    transform: 'translateY(-4px)',
                                                },
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                height="180"
                                                image={item.foto}
                                                alt={item.nome}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                            <CardContent>
                                                <Typography 
                                                    align="center" 
                                                    variant="subtitle1" 
                                                    sx={{ fontWeight: '600', color: 'text.primary' }}
                                                >
                                                    {item.nome}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Link>
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            )}

            {/* Seções de Transparência Filtradas */}
            {sections.map((section, index) => (
                <Box key={index} sx={{ mb: 4 }} itemScope itemType={section?.itemType}>
                    <Typography variant="h5" component="div" fontWeight="700" gutterBottom>
                        {section.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {section.description}
                    </Typography>

                    <Grid container spacing={3} itemScope itemType={section?.itemType}>
                        {section.items
                            .filter((item) => item.title.toLowerCase().includes(searchTerm))
                            .map((item, i) => (
                                <Grid item xs={12} sm={6} md={4} key={i} itemScope itemProp={item.itemprop} itemType={item.itemType}>
                                    <Link style={{ textDecoration: 'none' }} to={item.link}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                borderRadius: '12px',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                '&:hover': {
                                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                    transform: 'translateY(-4px)',
                                                },
                                            }}
                                        >
                                            <CardContent
                                                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3 }}
                                                itemScope
                                                itemProp={item.itemprop}
                                                itemType={item.itemType}
                                            >
                                                <IconButton
                                                    color="primary"
                                                    size="large"
                                                    sx={{ mb: 1.5, bgcolor: 'rgba(15, 113, 253, 0.08)', p: 1.5 }}
                                                    tabIndex={-1}
                                                >
                                                    {item.icon}
                                                </IconButton>
                                                <Typography
                                                    align="center"
                                                    sx={{ fontSize: 17, fontWeight: '600', color: 'text.primary' }}
                                                >
                                                    {item.title}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Link>
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            ))}
        </Container>
    );
}